import { Controller } from 'stimulus';

/**
 * Toggles between a compact summary view and the full notification schedule form
 * on the organisation user creation wizard step. Keeps the step short by default;
 * users can click "Edit schedule" to expand and edit.
 */
export default class extends Controller {
  static targets = ['summary', 'form'];

  showForm() {
    if (this.hasSummaryTarget) this.summaryTarget.classList.add('d-none');
    if (this.hasFormTarget) this.formTarget.classList.remove('d-none');
  }

  showSummary() {
    if (this.hasFormTarget) this.formTarget.classList.add('d-none');
    if (this.hasSummaryTarget) this.summaryTarget.classList.remove('d-none');
  }
}
